/**
 * Features supported by ProjectWise Server Plugin
 */
export class PWServerSupports {
    static get version() {
        return this.pluginVersion;
    }
    static set version(version) {
        this.pluginVersion = version;
    }
    /**
     * Api ancestor in WSG queries
     * @returns version >= 3.2
     */
    static get apiAncestor() {
        return this.minimumVersion(3.2);
    }
    /**
     * Version with api ancestor bug
     * @returns version == 3.2
     */
    static get apiAncestorBug() {
        return this.exactVersion(3.2);
    }
    /**
     * Search for projects
     * @returns version >= 3.2
     */
    static get folderSearch() {
        return this.minimumVersion(3.2);
    }
    /**
     * ProjectWise Drive
     * @returns version >= 3.2
     */
    static get pwDrive() {
        return this.minimumVersion(3.2);
    }
    /**
     * Queryable environment attribute properties
     * @returns version >= 3.3
     */
    static get attributeInterfaces() {
        return this.minimumVersion(3.3);
    }
    /**
     * OutTo property on data items
     * @returns version >= 3.3
     */
    static get outToProperty() {
        return this.minimumVersion(3.3);
    }
    /**
     * Retired properties on data items
     * @returns version >= 3.3
     */
    static get retiredProperties() {
        return this.minimumVersion(3.3);
    }
    /**
     * State and Workflow properties on data items
     * @returns version >= 3.3
     */
    static get stateWorkflowProperties() {
        return this.minimumVersion(3.3);
    }
    /**
     * Query Views created in PW Explorer
     * @returns version >= 3.3
     */
    static get views() {
        return this.minimumVersion(3.3);
    }
    /**
     * Query document code wizard forms
     * @returns version >= 3.4
     */
    static get docCodeWizard() {
        return this.minimumVersion(3.4);
    }
    /**
     * Search with Full Text Retrieval
     * @returns version >= 3.4
     */
    static get fullTextSearch() {
        return this.minimumVersion(3.4);
    }
    /**
     * Move older versions of documents
     * @returns version >= 3.4
     */
    static get moveVersions() {
        return this.minimumVersion(3.4);
    }
    /**
     * Default form definition for environment
     * @returns version >= 3.4
     */
    static get projectDefaultFormDef() {
        return this.minimumVersion(3.4);
    }
    /**
     * Environment properties trigger doc code updates
     * @returns version >= 3.41
     */
    static get triggeredDocCodeProperties() {
        return this.minimumVersion(3.41);
    }
    /**
     * Query user document permissions
     * @returns version >= 3.433
     */
    static get userDocumentPermissions() {
        return this.minimumVersion(3.433);
    }
    /**
     * Search with All Content Search
     * @returns version >= 3.436
     */
    static get allContentSearch() {
        return this.minimumVersion(3.436);
    }
    /**
     * Synchronize PW Drive with server
     * @returns version >= 3.436
     */
    static get driveSyncSupport() {
        return this.minimumVersion(3.436);
    }
    /**
     * Query project resource metadata
     * @returns version >= 3.439
     */
    static get projectResourceMetadata() {
        return this.minimumVersion(3.439);
    }
    /**
     * Perform actions (create, move, modify items) on flat sets
     * @returns version >= 3.449
     */
    static get flatSetActions() {
        return this.minimumVersion(3.449);
    }
    /**
     * Query user folder permissions
     * @returns version >= 3.449
     */
    static get userFolderPermissions() {
        return this.minimumVersion(3.449) && !this.exactVersion(3.631);
    }
    /**
     * Improved performance when querying related environment properties
     * @returns version >= 3.456
     */
    static get environmentQueryPerformance() {
        return this.minimumVersion(3.456);
    }
    /**
     * Default view for saved searches
     * @returns version >= 3.456
     */
    static get savedSearchDefaultView() {
        return this.minimumVersion(3.456);
    }
    /**
     * Create renditions for documents
     * @returns version >= 3.457
     */
    static get createRenditions() {
        return this.minimumVersion(3.457);
    }
    /**
     * Perform operations on master reference files (LogicalSets)
     * @returns version >= 3.457
     */
    static get masterReferenceFileOperations() {
        return this.minimumVersion(3.457);
    }
    /**
     * OutToMe query
     * @returns version >= 3.459
     */
    static get outToMePage() {
        return this.minimumVersion(3.459);
    }
    /**
     * Create version on LogicalSets
     * @returns version >= 5.17
     */
    static get logicalSetVersion() {
        return this.minimumVersion(5.17);
    }
    /**
     * Copy items to new folder
     * @returns version >= 6.26
     */
    static get copyItems() {
        return this.minimumVersion(6.26);
    }
    /**
     * Query saved searches by work area
     * @returns version >= 6.26
     */
    static get workAreaSavedSearchQuery() {
        return this.minimumVersion(6.26);
    }
    /**
     * Attribute exchange on download and check out
     * @returns version >= 7.13
     */
    static get attributeExchange() {
        return this.minimumVersion(7.13);
    }
    /**
     * Copy item with DCW including attributes
     * @returns version >= 7.20
     */
    static get dcwCopy() {
        return this.minimumVersion(7.2);
    }
    /**
     * Replace logical set file while preserving references
     * @returns version >= 230000.34
     */
    static get logicalSetReplaceReferences() {
        return this.minimumVersion(230000.34);
    }
    /**
     * Supports ProjectRichProject relationship
     * @returns version >= 230603.12
     */
    static get closestWorkArea() {
        return this.minimumVersion(230603.12);
    }
    static minimumVersion(version) {
        return this.pluginVersion >= version;
    }
    static exactVersion(version) {
        return this.pluginVersion == version;
    }
}
PWServerSupports.pluginVersion = 0;
